import './_mini-cart-promo.scss';

export default () => {};
